(function () {
  var sa = document.querySelector('[data-hh-sa]'); if (!sa || sa.dataset.ready) return; sa.dataset.ready = '1';
  document.body.appendChild(sa);
  var product = {}; try { product = JSON.parse(sa.querySelector('[data-hh-sa-product]').textContent); } catch (e) {}
  var sizeIdx = parseInt(sa.dataset.sizeIndex, 10);
  var state = { gender: sa.dataset.gender || '', cat: sa.dataset.cat || 'top', unit: 'us', build: null, fit: null, width: null, between: null };
  var LABELS = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  var flow = [], pos = 0, result = null;
  var $ = function (q) { return sa.querySelector(q); }, $$ = function (q) { return Array.prototype.slice.call(sa.querySelectorAll(q)); };

  var FIT = {
    top:    { q: 'How do you like your knitwear and tops to fit?', opts: [['-0.4', 'Close', 'Body-skimming'], ['0', 'Regular', 'Classic cut'], ['0.5', 'Relaxed', 'Easy & roomy']] },
    bottom: { q: 'How do you like your pants to fit?', opts: [['-0.4', 'Slim', 'Close through hip'], ['0', 'Regular', 'Classic cut'], ['0.5', 'Relaxed', 'Room to move']] },
    outer:  { q: 'What will you usually wear underneath?', opts: [['-0.2', 'A light shirt', 'Thin layer'], ['0.2', 'A sweater', 'Medium layer'], ['0.6', 'A chunky knit', 'Heavy layer']] },
    dress:  { q: 'Compared to your shoulders, your hips are…', opts: [['-0.3', 'Narrower', ''], ['0', 'About the same', ''], ['0.5', 'Wider', '']] }
  };

  function hasSizeOption() { return sizeIdx >= 0 && product.options && product.options[sizeIdx]; }
  function sizeValues() { return hasSizeOption() ? (product.options_with_values ? product.options_with_values[sizeIdx].values : uniq(product.variants.map(function (v) { return v.options[sizeIdx]; }))) : []; }
  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }

  function buildFlow() {
    flow = [];
    if (!state.gender) flow.push('gender');
    if (state.cat === 'shoes') flow = flow.concat(['shoe', 'width', 'between']);
    else flow = flow.concat(['body', 'build', 'fit']);
    flow.push('result');
  }

  function renderFit() {
    var f = FIT[state.cat] || FIT.top;
    $('[data-fit-q]').textContent = f.q;
    $('[data-fit-opts]').innerHTML = f.opts.map(function (o) { return '<button type="button" class="hh-sa__opt" data-set="fit" data-val="' + o[0] + '">' + o[1] + (o[2] ? '<small>' + o[2] + '</small>' : '') + '</button>'; }).join('');
    bindOpts($('[data-fit-opts]'));
    var lb = $('[data-label-broad]'); if (lb) lb.textContent = state.gender === 'men' ? 'Broad / athletic' : 'Curvy / broad';
  }

  function fillShoeSelect() {
    var sel = $('[data-in="shoe"]'); var min = state.gender === 'men' ? 6 : 5, max = state.gender === 'men' ? 14 : 12; var h = '<option value="">Select…</option>';
    for (var s = min; s <= max; s += 0.5) h += '<option value="' + s + '">US ' + (state.gender === 'men' ? 'Men ' : 'Women ') + s + '</option>';
    sel.innerHTML = h;
  }

  function show() {
    var step = flow[pos];
    $$('[data-step]').forEach(function (el) { el.hidden = el.dataset.step !== step; });
    var counted = flow.filter(function (s) { return s !== 'result'; });
    $$('[data-hh-steps] span').forEach(function (b, i) { b.style.display = i < counted.length ? '' : 'none'; b.classList.toggle('is-done', i < Math.min(pos + 1, counted.length) || step === 'result'); });
    $('[data-hh-nav]').hidden = step === 'result';
    $('[data-hh-back]').style.visibility = pos === 0 ? 'hidden' : 'visible';
    $('[data-hh-next]').textContent = flow[pos + 1] === 'result' ? 'See my size' : 'Next';
    if (step === 'fit' || step === 'build') renderFit();
    if (step === 'shoe') fillShoeSelect();
    $$('[data-hh-err]').forEach(function (e) { e.textContent = ''; });
  }

  function valid() {
    var step = flow[pos];
    if (step === 'gender') return !!state.gender;
    if (step === 'build') return state.build !== null;
    if (step === 'fit') return state.fit !== null;
    if (step === 'width') return state.width !== null;
    if (step === 'between') return state.between !== null;
    if (step === 'body') {
      var h = heightIn(), w = weightLb();
      if (!h || !w || h < 52 || h > 84 || w < 80 || w > 400) { $('[data-step="body"] [data-hh-err]').textContent = 'Please enter your height and weight.'; return false; }
      return true;
    }
    if (step === 'shoe') { if (!$('[data-in="shoe"]').value) { $('[data-step="shoe"] [data-hh-err]').textContent = 'Please choose your usual size.'; return false; } return true; }
    return true;
  }

  function heightIn() {
    if (state.unit === 'us') return parseInt($('[data-in="ft"]').value, 10) * 12 + parseInt($('[data-in="inch"]').value, 10);
    var cm = parseFloat($('[data-in="cm"]').value); return cm ? cm / 2.54 : 0;
  }
  function weightLb() {
    if (state.unit === 'us') return parseFloat($('[data-in="lbs"]').value) || 0;
    var kg = parseFloat($('[data-in="kg"]').value); return kg ? kg * 2.2046 : 0;
  }

  function apparelScore() {
    var w = weightLb(), h = heightIn(), base;
    if (state.gender === 'men') {
      base = w < 135 ? 1 : w < 156 ? 2 : w < 181 ? 3 : w < 206 ? 4 : w < 236 ? 5 : w < 266 ? 6 : 7;
      if (h >= 74) base += 0.4; else if (h <= 66) base -= 0.3;
    } else {
      base = w < 115 ? 1 : w < 131 ? 2 : w < 149 ? 3 : w < 169 ? 4 : w < 191 ? 5 : w < 215 ? 6 : 7;
      if (h >= 69) base += (state.cat === 'dress' || state.cat === 'outer' || state.cat === 'bottom') ? 0.5 : 0.3; else if (h <= 62) base -= 0.3;
    }
    return base + (state.build || 0) + (state.fit || 0);
  }

  function nearestAvailable(label) {
    var vals = sizeValues(); if (!vals.length) return { value: label, available: true };
    function norm(v) { return String(v).toUpperCase().replace(/\s+/g, ' ').trim(); }
    function idxOf(v) { var n = norm(v).split(/[\s\/(]/)[0].replace('XXXL', '3XL').replace('2XL', 'XXL'); return LABELS.indexOf(n); }
    var target = LABELS.indexOf(label), best = null, bestD = 99;
    vals.forEach(function (v) { var i = idxOf(v); if (i < 0) return; var avail = product.variants.some(function (vr) { return vr.options[sizeIdx] === v && vr.available; }); var d = Math.abs(i - target) + (avail ? 0 : 0.6); if (d < bestD) { bestD = d; best = { value: v, available: avail, exact: i === target }; } });
    return best || { value: label, available: true };
  }

  function shoeResult() {
    var us = parseFloat($('[data-in="shoe"]').value) + (state.width || 0) + (state.between || 0);
    us = Math.round(us * 2) / 2;
    var eu = state.gender === 'men' ? Math.round(us + 33) : Math.round(us + 31);
    var vals = sizeValues(), match = null;
    if (vals.length) {
      var nums = vals.map(function (v) { var m = String(v).match(/\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; });
      var isEU = nums.some(function (n) { return n && n >= 30; });
      var target = isEU ? eu : us, bestD = 99;
      vals.forEach(function (v, i) { if (nums[i] === null) return; var avail = product.variants.some(function (vr) { return vr.options[sizeIdx] === v && vr.available; }); var d = Math.abs(nums[i] - target) + (avail ? 0 : 0.4); if (d < bestD) { bestD = d; match = { value: v, available: avail, exact: d === 0 }; } });
    }
    return { label: match ? match.value : ('US ' + us), value: match ? match.value : null, available: match ? match.available : true, exact: match ? match.exact : true, us: us, eu: eu };
  }

  function compute() {
    if (state.cat === 'shoes') {
      var r = shoeResult();
      result = { value: r.value, label: r.label, exact: r.exact, available: r.available,
        why: 'Based on your usual US ' + (state.gender === 'men' ? "men's" : "women's") + ' size' + (state.width > 0 ? ', a wider foot' : state.width < 0 ? ', a narrower foot' : '') + ' and how you size between sizes. Equivalent: US ' + r.us + ' · EU ' + r.eu + '.' };
    } else {
      var score = apparelScore(); var i = Math.max(1, Math.min(7, Math.round(score)));
      var frac = Math.abs(score - Math.round(score));
      var n = nearestAvailable(LABELS[i]);
      var catTxt = { top: 'tops and knitwear', bottom: 'pants', outer: 'coats and jackets', dress: 'dresses and skirts' }[state.cat];
      result = { value: hasSizeOption() ? n.value : null, label: hasSizeOption() ? String(n.value) : LABELS[i], exact: n.exact !== false && frac < 0.35, available: n.available,
        why: 'Based on your height, weight and build, and the way our ' + catTxt + ' are cut' + (state.cat === 'outer' ? ' — with room for the layers you wear underneath' : '') + '.',
        alt: frac >= 0.35 ? 'You\'re close to the next size — ' + (score > Math.round(score) ? 'size up' : 'size down') + ' if you prefer a ' + (score > Math.round(score) ? 'roomier' : 'closer') + ' fit.' : '' };
    }
    $('[data-hh-size]').textContent = result.label;
    $('[data-hh-size-btn]').textContent = result.label;
    $('[data-hh-why]').textContent = result.why;
    $('[data-hh-alt]').textContent = result.alt || (result.available === false ? 'This size is currently sold out — we suggest emailing us for alternatives.' : '');
    $('[data-hh-conf] span').textContent = result.exact ? 'Great match' : 'Good match';
    var atc = $('[data-hh-atc]'); atc.disabled = result.available === false; atc.style.display = result.value || !hasSizeOption() ? '' : 'none';
  }

  function addToCart() {
    var form = document.querySelector('form[action*="/cart/add"][id^="AddToCartForm"]') || document.querySelector('.product-single__form, form[action*="/cart/add"]');
    if (result.value && sizeIdx >= 0) {
      var radios = document.querySelectorAll('input[type="radio"][name*="' + (product.options[sizeIdx]) + '"], [data-index="option' + (sizeIdx + 1) + '"] input[type="radio"]');
      var hit = Array.prototype.find.call(radios, function (r) { return r.value === String(result.value); });
      if (hit) { hit.checked = true; hit.dispatchEvent(new Event('change', { bubbles: true })); }
      var sel = document.querySelector('select[data-index="option' + (sizeIdx + 1) + '"]');
      if (!hit && sel) { sel.value = String(result.value); sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    close();
    setTimeout(function () {
      var btn = form && form.querySelector('[type="submit"][name="add"], .add-to-cart, [type="submit"]');
      if (btn && !btn.disabled) btn.click();
      else if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 180);
  }

  function bindOpts(scope) {
    Array.prototype.forEach.call((scope || sa).querySelectorAll('.hh-sa__opt'), function (b) {
      if (b.dataset.bound) return; b.dataset.bound = 1;
      b.addEventListener('click', function () {
        var k = b.dataset.set; var v = b.dataset.val;
        Array.prototype.forEach.call(b.parentNode.querySelectorAll('.hh-sa__opt'), function (x) { x.classList.toggle('is-active', x === b); });
        state[k] = (k === 'gender') ? v : parseFloat(v);
        if (k === 'gender') buildFlow();
        setTimeout(next, 220);
      });
    });
  }

  function next() { if (!valid()) return; if (flow[pos + 1] === 'result') compute(); pos = Math.min(pos + 1, flow.length - 1); show(); }
  function back() { pos = Math.max(0, pos - 1); show(); }
  function reset() { state.build = state.fit = state.width = state.between = null; state.gender = sa.dataset.gender || ''; $$('.hh-sa__opt').forEach(function (o) { o.classList.remove('is-active'); }); buildFlow(); pos = 0; show(); }
  function open() { sa.hidden = false; document.documentElement.style.overflow = 'hidden'; tab('find'); reset(); var f = sa.querySelector('.hh-sa__panel'); f.setAttribute('tabindex', '-1'); f.focus(); }
  function close() { sa.hidden = true; document.documentElement.style.overflow = ''; }
  function tab(t) {
    $$('[data-hh-tab]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.hhTab === t); });
    $$('[data-hh-pane]').forEach(function (p) { p.hidden = p.dataset.hhPane !== t; });
    $('[data-hh-steps]').style.visibility = t === 'find' ? 'visible' : 'hidden';
    var g = state.gender, c = state.cat;
    $$('[data-chart]').forEach(function (ch) { ch.hidden = c === 'shoes' ? ch.dataset.chart !== 'shoes' : (g ? ch.dataset.chart !== g : ch.dataset.chart === 'shoes'); });
  }

  bindOpts();
  $$('[data-unit]').forEach(function (b) { b.addEventListener('click', function () { state.unit = b.dataset.unit; $$('[data-unit]').forEach(function (x) { x.classList.toggle('is-active', x === b); }); $$('[data-units]').forEach(function (f) { f.hidden = f.dataset.units !== state.unit; }); }); });
  $$('[data-hh-tab]').forEach(function (b) { b.addEventListener('click', function () { tab(b.dataset.hhTab); }); });
  $('[data-hh-next]').addEventListener('click', next);
  $('[data-hh-back]').addEventListener('click', back);
  $('[data-hh-restart]').addEventListener('click', reset);
  $('[data-hh-atc]').addEventListener('click', addToCart);
  $$('[data-hh-sa-close]').forEach(function (b) { b.addEventListener('click', close); });
  sa.addEventListener('click', function (e) { if (e.target === sa) close(); });
  document.addEventListener('keydown', function (e) { if (!sa.hidden && e.key === 'Escape') close(); });
  document.addEventListener('click', function (e) { var t = e.target.closest && e.target.closest('[data-hh-size-open]'); if (t) { e.preventDefault(); open(); if (t.dataset.hhSizeOpen === 'chart') tab('chart'); } });
  $$('input[data-in]').forEach(function (i) { i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); next(); } }); });
})();